
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Ref } from "vue-property-decorator";
    import { VForm } from "@/vForm";
    import * as toastr from "toastr";
    import ApiClient from "@/utilities/ApiClient";
    import Utils from "@/utilities/Utils";
    import ApiButton from "@/vue/components/ApiButton.vue";
    import ConfirmDialogue from "@/vue/components/ConfirmDialogue.vue";
    import DatePicker from "@/vue/components/DatePicker.vue";
    import { ISaveResponse } from "@/model/ISaveResponse";
    import { IResource, Resource } from "@/model/Resource";

    @Component({ components: { ApiButton, ConfirmDialogue, DatePicker } })
    export default class ResourceDialogue extends Vue {

        //
        // -- properties
        //

        @Ref("resourceForm") private readonly resourceForm!: VForm;
        showDialogue: boolean = false;
        dialogueTitle: string = "";
        resource: Resource = new Resource();
        get canDelete(): boolean { return !Utils.isEmptyId(this.resource.id); }

        //
        // -- methods
        //

        add(): void {
            this.reset();
            this.dialogueTitle = "Add Resource";
            this.showDialogue = true;
        }

        async edit(id: string): Promise<void> {
            this.reset();
            this.dialogueTitle = "Edit Resource";
            const resourceData: IResource = await ApiClient.get(`api/resource/Load?id=${id}`);
            this.resource.update(resourceData);
            this.showDialogue = true;
        }

        private reset(): void {
            Utils.resetObject(this.resource);
            this.resourceForm?.resetValidation();
        }

        private async save(): Promise<void> {
            if (!this.resourceForm.validate()) {
                toastr.warning("Please fix highlighted issues", "Cannot Save");
                return;
            }
            const response: ISaveResponse = await ApiClient.post("/api/resource/save", this.resource, "resource-save");
            if(this.resource.isNew) this.resource.id = response.newID;
            toastr.success("Saved");
            this.$emit("saved");
            this.showDialogue = false;
        }

        private confirmDelete(): void {
            const dialog: ConfirmDialogue = this.$refs.deleteDialogue as ConfirmDialogue;
            dialog.show();
        }

        private async doDelete(): Promise<void> {
            await ApiClient.post("/api/resource/delete", this.resource, "resource-delete");
            toastr.warning("Deleted");
            this.$emit("saved");
            this.showDialogue = false;
        }
    }
